import React from 'react';
import { Route } from "react-router-dom";
import About from "./about";
import Discover from "./discover";
import Sessions from "./sessions";
import Credits from "./credits";
import Social from "./social";
import Profile from "./profile";
import SideBar from "./sidebar"

import './styles/fonts.css';

import banner from './images/banner.png';
import collab from "./images/collaboration.jpg"
import brandBanner from "./images/logo.png"
import PublicProfile from './publicProfile';

export default class Body extends React.Component {
    render() {
        var leftPaneStyle = {
            padding: "0 4% 0 6%",
            textAlign: "left"
        };
        var rightPaneStyle = {
            padding: "0 10% 0 10%",
            textAlign: "justify"
        };
        var bannerStyle = {
            marginTop: "2%",
            borderRadius: "10px"
        }
        return (
            <div className="content row-fluid">
                <div className="row">
                    <div className="col-md-3" style={leftPaneStyle}>  
                    {this.props.AuthState.user ?
                        <SideBar/>   
                        :
                        <div className="row" style={{marginTop:"12%"}}>
                           
                        </div>
                    }       
                    </div>
                    <div className="col-md-9" style={rightPaneStyle}>
                        <img alt="" src={banner} className="img-fluid" style={bannerStyle}></img>
                        <Route path="/discover/" component={Discover} />
                        <Route path="/sessions/" component={Sessions} />
                        <Route path="/credits/" component={Credits} />
                        <Route path="/social/" component={Social} />
                        <Route path="/publicProfile/" component={PublicProfile} />
                        <Route path="/profile/" component={()=><Profile AuthState={this.props.AuthState}/>}  />
                        <Route exact path="/" component={About} />
                    </div>
                </div>
            </div>
        );
    }
}